import { useState } from "react";
import { Page } from "@boundary/layouts/pageLayout";
import { PhotoDiscount20 } from "@boundary/widgets/photoDiscount";
import { ProfileLink } from "@boundary/widgets/profileLink";
import { MenuActions } from "@boundary/widgets/actions";
import { useAuth } from "@boundary/_hooks";
import { MenuFooter } from "@boundary/components/menuFooter";
import { LogoColor } from "@boundary/components/phodoLogos";
import styles from "./menu.module.scss";

/**
{showPromo && (
  <PhotoDiscount20 onCloseClick={handleClosePromo} />
)}
*/

export function MenuPage() {
  const { user } = useAuth();
  const [showPromo, setShowPromo] = useState(true);

  const handleClosePromo = () => {
    setShowPromo(false);
  };

  return (
    <Page screenBackground="sub">
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Header back center={<LogoColor size="medium" />} />
        <Page.DisplayZone.Body className={styles.content} padded={false}>
        <div className={styles.profileLink}>
          <ProfileLink
          phone={user?.phone_number ?? "–"}
          photo={user?.photo}
          name={user?.name}
        />
        </div>
          <div className={styles.menuActions}>
          <MenuActions />
          </div>
          <div className={styles.menuFooter}>
          <MenuFooter />
        </div>
        </Page.DisplayZone.Body>
      </Page.DisplayZone>
    </Page>
  );
}
